module.exports = __webpack_public_path__ + "static/media/gold.37912087.webp";